// Spanish for the agents, chat, sala, AI cost page and shared lib labels (23 Oct 2026).
export const AGENTS_CHAT: Record<string, string> = {
  " (+{n} more in progress)": " (+{n} más en curso)",
  " (1 day after the plan)": " (1 día después de lo previsto)",
  " (1 day after the planned end)": " (1 día después del final previsto)",
  " (1 day ahead of plan)": " (1 día antes de lo previsto)",
  " (1 day before the planned end)": " (1 día antes del final previsto)",
  " (as planned)": " (según lo previsto)",
  " ({n} days after the plan)": " ({n} días después de lo previsto)",
  " ({n} days after the planned end)": " ({n} días después del final previsto)",
  " ({n} days ahead of plan)": " ({n} días antes de lo previsto)",
  " ({n} days before the planned end)": " ({n} días antes del final previsto)",
  "1 day behind": "1 día de retraso",
  "1 day of work last week": "1 día de trabajo la semana pasada",
  "1 day of work this week": "1 día de trabajo esta semana",
  "1 suggestion": "1 sugerencia",
  "1 thing to look at": "1 cosa que revisar",
  "A month at this pace": "Un mes a este ritmo",
  "AI cost": "Coste de IA",
  "Admin tools": "Herramientas de administración",
  "Alex: first and last person": "Alex: primera y última persona",
  "All phases finished": "Todas las fases terminadas",
  "All projects": "Todos los proyectos",
  "All {n} phases finished": "Las {n} fases terminadas",
  "Also in progress: {list}": "También en curso: {list}",
  "Analyses": "Análisis",
  "Answers questions in \"Ask Zoe\"": "Responde preguntas en \"Pregunta a Zoe\"",
  "Apply": "Aplicar",
  "Ask Zoe": "Pregunta a Zoe",
  // 29 Oct 2026: Zoe's card has a typing box
  "Chat with me about the site": "Habla conmigo sobre la obra",
  "Type a question…": "Escribe una pregunta…",
  "Ask Zonoo": "Pregunta a Zonoo",
  "Ask me anything about your site": "Pregúntame lo que quieras sobre tu obra",
  "Avg cost": "Coste medio",
  "Avg duration": "Duración media",
  "Back": "Volver",
  "Breakdown by purpose": "Desglose por uso",
  "Breakdown by site": "Desglose por obra",
  "Brief": "Breve",
  "Budget and credits →": "Presupuesto y créditos →",
  "By feature": "Por función",
  "By site": "Por obra",
  "Cache r/c": "Caché l/c",
  "Cache tokens": "Tokens de caché",
  "Calls": "Llamadas",
  "Camera reference scene": "Escena de referencia de la cámara",
  "Change dates": "Cambiar fechas",
  "Chat isn't turned on for your account yet.": "El chat aún no está activado para tu cuenta.",
  "Checks every day who was on site": "Revisa cada día quién estuvo en obra",
  "Checks movement photos once a day": "Revisa las fotos de movimiento una vez al día",
  "Clear": "Borrar",
  "Close": "Cerrar",
  "Close chat": "Cerrar chat",
  "Close chat backdrop": "Cerrar el fondo del chat",
  "Close history menu": "Cerrar el menú del historial",
  "Compares photos on request": "Compara fotos cuando se pide",
  "Composed view": "Vista combinada",
  "Confirm": "Confirmar",
  "Confirm records {name} as finished on": "Confirmar registra {name} como terminada el",
  "Confirm records {name} as started on": "Confirmar registra {name} como empezada el",
  "Conversation history": "Historial de conversaciones",
  "Cost": "Coste",
  "Could not load analyses.": "No se pudieron cargar los análisis.",
  "Could not load captures.": "No se pudieron cargar las capturas.",
  "Could not load events.": "No se pudieron cargar los eventos.",
  "Could not load timeline.": "No se pudo cargar el cronograma.",
  "Date": "Fecha",
  "Describes a new camera view once": "Describe una vez la vista de una cámara nueva",
  "Duration": "Duración",
  "Empty response.": "Respuesta vacía.",
  "Enlarge photo: {caption}": "Ampliar foto: {caption}",
  "Errors": "Errores",
  "Events by hour": "Eventos por hora",
  "Evidence comparison": "Comparación de pruebas",
  "Feature": "Función",
  "Finish date": "Fecha de fin",
  "Finished {date}": "Terminada el {date}",
  "Finished {when}": "Terminada {when}",
  "Floor plan with where the work was this week: {list}": "Plano con dónde se trabajó esta semana: {list}",
  "Floor plan with where the work was today: {list}": "Plano con dónde se trabajó hoy: {list}",
  "Form": "Formulario",
  "From": "Desde",
  "Hello, I'm the Zonoo Assistant. I can help with projects, cameras, alerts and summaries. What do you need?": "Hola, soy el asistente de Zonoo. Puedo ayudarte con proyectos, cámaras, alertas y resúmenes. ¿Qué necesitas?",
  "Hide ▴": "Ocultar ▴",
  "History": "Historial",
  "Hourly photo checks": "Revisión horaria de fotos",
  "I check every day who was on site, and what changed.": "Reviso cada día quién estuvo en obra y qué cambió.",
  "I draw on your plan where the work happened.": "Marco en tu plano dónde se trabajó.",
  "I keep the plan. I tell you what's next, and I speak up if something starts running late.": "Llevo el plan. Te digo qué viene ahora y aviso si algo empieza a retrasarse.",
  "I watch the camera all day. Ask me anything about your site, and I'll show you the photos.": "Vigilo la cámara todo el día. Pregúntame lo que quieras sobre tu obra y te enseño las fotos.",
  "In progress since {date}": "En curso desde el {date}",
  "In progress since {date} · {pace}": "En curso desde el {date} · {pace}",
  "Independent from the filter above.": "Independiente del filtro de arriba.",
  "Inspector": "Inspector",
  "Last 30 days": "Últimos 30 días",
  "Last 7 days": "Últimos 7 días",
  "Loading analyses…": "Cargando análisis…",
  "Loading captures…": "Cargando capturas…",
  "Loading events…": "Cargando eventos…",
  "Loading timeline…": "Cargando cronograma…",
  "Loading…": "Cargando…",
  "Map not set up yet": "El plano aún no está preparado",
  "Max compares the plan with the phases marked as started or finished.": "Max compara el plan con las fases marcadas como empezadas o terminadas.",
  "Max suggests (admins)": "Max sugiere (administradores)",
  "Message": "Mensaje",
  "Model": "Modelo",
  "Monday, {time}": "el lunes, {time}",
  "Most work": "Más trabajo",
  "Must be YYYY-MM-DD": "Debe ser AAAA-MM-DD",
  "Must be a number": "Debe ser un número",
  "New chat": "Nuevo chat",
  "Next: {name}, from {date}": "Siguiente: {name}, desde el {date}",
  "Next: {name}, from {date}.": "Siguiente: {name}, desde el {date}.",
  "No calls in the selected range.": "No hay llamadas en el periodo elegido.",
  "No captures stored for that day.": "No hay capturas guardadas de ese día.",
  "No failed AI calls in the last 7 days.": "Ninguna llamada de IA fallida en los últimos 7 días.",
  "No one seen": "Nadie visto",
  "No past conversations here yet.": "Aún no hay conversaciones anteriores aquí.",
  "No phase marked as started yet": "Aún no hay ninguna fase marcada como empezada",
  "No plan uploaded yet": "Aún no hay plan subido",
  "No plan yet": "Aún no hay plan",
  "No work on the map yet this week": "Esta semana aún no hay trabajo en el plano",
  "No work on the map yet today": "Hoy aún no hay trabajo en el plano",
  "No work seen this week:": "Sin trabajo visto esta semana:",
  "No work seen today:": "Sin trabajo visto hoy:",
  "No working day with photos yet this week.": "Esta semana aún no hay ningún día laborable con fotos.",
  "Nobody seen on camera": "No se ha visto a nadie en cámara",
  "Not enough photos to tell": "No hay suficientes fotos para saberlo",
  "Not linked to a site": "Sin obra asignada",
  "Not started": "Sin empezar",
  "Not yet": "Todavía no",
  "Now: Phase {n} · {name}": "Ahora: fase {n} · {name}",
  "Old summaries (switched off)": "Resúmenes antiguos (desactivados)",
  "On schedule": "En plazo",
  // 24 Oct 2026: Max, simplified (on schedule or how late)
  "I check the works against the plan and tell you if they are on schedule or late.": "Comparo la obra con el plan y te digo si va en plazo o con retraso.",
  "Schedule": "Plazos",
  "Every phase is on time against the plan.": "Todas las fases van en plazo según el plan.",
  "Hide the plan": "Ocultar el plan",
  "See the plan": "Ver el plan",
  "Confirm or correct it in Admin tools below.": "Confírmalo o corrígelo abajo, en Herramientas de admin.",
  "Timing may change": "Los plazos pueden cambiar",
  "{name} was planned to start on {date} and hasn't started yet.": "{name} estaba previsto empezar el {date} y aún no ha empezado.",
  "From the photos, {name} started on {date}.": "Según las fotos, {name} empezó el {date}.",
  "From the photos, {name} finished on {date}.": "Según las fotos, {name} terminó el {date}.",
  "If confirmed: {status}.": "Si se confirma: {status}.",
  "Waiting for the site manager to confirm.": "Pendiente de confirmación del jefe de obra.",
  "On site this week": "En obra esta semana",
  "Once a plan is uploaded, Max checks it every day.": "Cuando se sube un plan, Max lo revisa cada día.",
  "Only what the camera can see. Tap a photo to see it bigger.": "Solo lo que ve la cámara. Toca una foto para verla más grande.",
  "Only what the cameras can see. Tap a spot to see its photo.": "Solo lo que ven las cámaras. Toca un punto para ver su foto.",
  "Other": "Otros",
  "Per month": "Al mes",
  "Phase {n} · {name}": "Fase {n} · {name}",
  "Photos": "Fotos",
  "Planned from {date}, but the camera already saw work that belongs to it:": "Previsto desde el {date}, pero la cámara ya vio trabajo de esta fase:",
  "Planned from {date}. The camera saw work that belongs to it:": "Previsto desde el {date}. La cámara vio trabajo de esta fase:",
  "Project documents": "Documentos del proyecto",
  "Purpose": "Uso",
  "Reads the camera photos every hour": "Lee las fotos de la cámara cada hora",
  "Reads uploaded plans and schedules": "Lee los planos y planificaciones subidos",
  "Recent calls (latest 20)": "Llamadas recientes (últimas 20)",
  "Recent windows": "Periodos recientes",
  "Repeated {phrase} detected in {camera} coverage": "{phrase} repetida detectada en la zona de {camera}",
  "Required": "Obligatorio",
  "Retired 2 Oct": "Retirados el 2 de oct.",
  "Retry": "Reintentar",
  "Retrying…": "Reintentando…",
  "See the evidence": "Ver las pruebas",
  "Seen on camera this week for this phase": "Visto en cámara esta semana para esta fase",
  "Selected — the assistant will respond shortly.": "Seleccionado: el asistente responderá en breve.",
  "Send": "Enviar",
  "Share": "Parte",
  "Show ▾": "Mostrar ▾",
  "Since then, the camera saw other work on {days}, but nothing for this phase. It may also be happening out of the camera's view.": "Desde entonces, la cámara vio otros trabajos el {days}, pero nada de esta fase. También puede estar haciéndose fuera de la vista de la cámara.",
  "Site": "Obra",
  "Site guide": "Guía de la obra",
  "Site manager": "Jefe de obra",
  "Site map": "Plano de obra",
  "So far: nobody seen": "Hasta ahora: no se ha visto a nadie",
  "So far: {who}, from about {time}": "Hasta ahora: {who}, desde las {time} aprox.",
  "Some work": "Algo de trabajo",
  "Start date": "Fecha de inicio",
  "Start new chat": "Empezar un chat nuevo",
  "Start vs latest photo": "Primera foto frente a la más reciente",
  "Started {when}": "Empezada {when}",
  "Status": "Estado",
  "Still working on this reply…": "Sigo trabajando en esta respuesta…",
  "Submit": "Enviar",
  "Submitted — the assistant will respond shortly.": "Enviado: el asistente responderá en breve.",
  "Tap a photo to see it bigger.": "Toca una foto para verla más grande.",
  "Technical details (for Engineering)": "Detalles técnicos (para Ingeniería)",
  "Tell me more about today's work": "Cuéntame más sobre el trabajo de hoy",
  "The assistant is unavailable. Please try again.": "El asistente no está disponible. Inténtalo de nuevo.",
  "The camera saw work that belongs to it:": "La cámara vio trabajo de esta fase:",
  "The contractor reported: {text}": "El contratista informó: {text}",
  "The last work that belongs to it, seen on camera:": "El último trabajo de esta fase visto en cámara:",
  "The reply was interrupted. Try again.": "La respuesta se interrumpió. Inténtalo de nuevo.",
  "This site's map isn't set up yet.": "El plano de esta obra aún no está preparado.",
  "This view has no content.": "Esta vista no tiene contenido.",
  "This view section couldn't be displayed.": "No se pudo mostrar esta sección de la vista.",
  "This week": "Esta semana",
  "Timeline": "Cronograma",
  "To": "Hasta",
  "To correct a date, press Undo, pick the right date, then mark it again.": "Para corregir una fecha, pulsa Deshacer, elige la fecha correcta y márcala otra vez.",
  "To upload or replace the plan, use Site setup (the gear at the top) › Project documents.": "Para subir o cambiar el plan, usa Configuración de la obra (el engranaje de arriba) › Documentos del proyecto.",
  "Today": "Hoy",
  "Today / This week texts": "Textos de Hoy / Esta semana",
  "Today, {time}": "Hoy, {time}",
  "Today: nobody seen yet": "Hoy: aún no se ha visto a nadie",
  "Today: up to 1 worker, from about {time}": "Hoy: hasta 1 trabajador, desde las {time} aprox.",
  "Today: up to {n} workers, from about {time}": "Hoy: hasta {n} trabajadores, desde las {time} aprox.",
  "Today: work in 1 spot": "Hoy: trabajo en 1 punto",
  "Today: work in {n} spots": "Hoy: trabajo en {n} puntos",
  "Toggle fullscreen": "Pantalla completa",
  "Tokens": "Tokens",
  "Tokens in": "Tokens de entrada",
  "Tokens in / out": "Tokens de entrada / salida",
  "Tokens out": "Tokens de salida",
  "Total cost": "Coste total",
  "Turns": "Turnos",
  "Type a message…": "Escribe un mensaje…",
  "Undo": "Deshacer",
  "Unsent draft": "Borrador sin enviar",
  "Untitled conversation": "Conversación sin título",
  "Up to 1 worker": "Hasta 1 trabajador",
  "Up to {n} workers": "Hasta {n} trabajadores",
  "Update progress (admins)": "Actualizar avance (administradores)",
  "Upload the floor plan with the cameras marked on it. I'll redraw it clean and, after you confirm, show every day where the work happened.": "Sube el plano con las cámaras marcadas. Lo redibujo limpio y, cuando lo confirmes, te muestro cada día dónde se trabajó.",
  "Viewing an older conversation": "Viendo una conversación anterior",
  "What needs attention?": "¿Qué necesita atención?",
  "What physically changed during the day": "Qué cambió físicamente durante el día",
  "What the AI behind Zonoo costs to run (photo checks, texts, chat). In US dollars.": "Lo que cuesta la IA de Zonoo (revisión de fotos, textos, chat). En dólares estadounidenses.",
  "What the cameras see": "Lo que ven las cámaras",
  "What would you like to know about this project?": "¿Qué te gustaría saber de este proyecto?",
  "When": "Cuándo",
  "Where the work was this week": "Dónde se trabajó esta semana",
  "Where the work was today": "Dónde se trabajó hoy",
  "Where we are": "Dónde estamos",
  "Window": "Periodo",
  "Worked": "Se trabajó",
  "Writes the site updates clients read": "Escribe las novedades de obra que leen los clientes",
  "Yesterday": "Ayer",
  "Your site team": "Tu equipo de obra",
  "Zoe chat": "Chat de Zoe",
  "Zonoo Assistant": "Asistente de Zonoo",
  "around {time}": "hacia las {time}",
  "end of day": "final del día",
  "end of week": "final de la semana",
  "error": "error",
  "first person seen": "primera persona vista",
  "from the last 7 days": "según los últimos 7 días",
  "image unavailable": "imagen no disponible",
  "last person seen": "última persona vista",
  "last seen": "última vista",
  "latest": "la más reciente",
  "nighttime activity": "actividad nocturna",
  "no failures": "sin fallos",
  "nothing yet": "nada todavía",
  "ok": "ok",
  "on {date}": "el {date}",
  "start of day": "inicio del día",
  "start of week": "inicio de la semana",
  "started 1 day after the plan": "empezó 1 día después de lo previsto",
  "started 1 day ahead of plan": "empezó 1 día antes de lo previsto",
  "started as planned": "empezó según lo previsto",
  "started {n} days after the plan": "empezó {n} días después de lo previsto",
  "started {n} days ahead of plan": "empezó {n} días antes de lo previsto",
  "the camera": "la cámara",
  "today": "hoy",
  "tomorrow, {time}": "mañana, {time}",
  "{category} activity": "actividad de {category}",
  "{name} may be finished.": "{name} puede estar terminada.",
  "{name} may have started as planned.": "{name} puede haber empezado según lo previsto.",
  "{name} may have started early.": "{name} puede haber empezado antes de tiempo.",
  "{name} may have started.": "{name} puede haber empezado.",
  "{name} was planned to finish on {date} and is still in progress.": "{name} estaba previsto terminar el {date} y sigue en curso.",
  "{name} was planned to start on {date} and isn't marked as started.": "{name} estaba previsto empezar el {date} y no está marcado como empezado.",
  "{name}: day {day} of {total}{more}.": "{name}: día {day} de {total}{more}.",
  "{n} days behind": "{n} días de retraso",
  "{n} days of work last week": "{n} días de trabajo la semana pasada",
  "{n} days of work this week": "{n} días de trabajo esta semana",
  "{n} phases in the plan": "{n} fases en el plan",
  "{n} selected": "{n} seleccionadas",
  "{n} suggestions": "{n} sugerencias",
  "{n} things to look at": "{n} cosas que revisar",
  "{who} · seen around {time}": "{who} · vistos hacia las {time}",
  "{who} · seen from about {from} to {to}": "{who} · vistos desde las {from} hasta las {to} aprox.",
  // 29 Oct 2026 (S1): site team cards, a line on what they do + today's pill.
  "I check the plan every day": "Reviso el plan cada día",
  "I check who was on site": "Compruebo quién estuvo en la obra",
  "I map where the work was": "Marco en el plano dónde se trabajó",
  "Work today, from {time}": "Trabajo hoy, desde las {time}",
  "Nobody seen yet today": "Hoy aún no se ha visto a nadie",
  "No photos yet today": "Hoy aún no hay fotos",
  "Work in 1 spot today": "Trabajo en 1 punto hoy",
  "Work in {n} spots today": "Trabajo en {n} puntos hoy",
  // 29 Oct 2026 (P3): team cards, label + value.
  "On site today": "Hoy en la obra",
  "From {time}": "Desde las {time}",
  "Nobody seen yet": "Aún no se ha visto a nadie",
  "No photos yet": "Aún no hay fotos",
  "Work in 1 spot": "Trabajo en 1 punto",
  "Work in {n} spots": "Trabajo en {n} puntos",
  "No work on the map yet": "Aún no hay trabajo en el plano",
  "Needs a look": "Para revisar",
  "Ask about the site…": "Pregunta sobre la obra…",
}
